import { render, staticRenderFns } from "./NoteItem.vue?vue&type=template&id=195e0409&scoped=true&lang=pug&"
import script from "./NoteItem.vue?vue&type=script&lang=js&"
export * from "./NoteItem.vue?vue&type=script&lang=js&"
import style0 from "./NoteItem.vue?vue&type=style&index=0&id=195e0409&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195e0409",
  null
  
)

export default component.exports